import axios from "axios";

const reportSchedules = {
  namespaced: true,
  state: {
    schedules: null,
    paginate: null
  },
  mutations: {
    async setState(state, data){
      state.schedules = data.data;
      state.paginate = data;
    },
  },
  actions: {
    fetchSchedules: ({commit}) => axios.get(`/ajax/reports/get-my-schedules`)
        .then(({data}) => commit('setState', data)),
    deleteSchedules: ({commit}, payload) => axios.post(`/ajax/reports/delete-schedules`, payload),
  }
};

export default reportSchedules;
